import { render, staticRenderFns } from "./TagFiltro.vue?vue&type=template&id=18d48517"
import script from "./TagFiltro.vue?vue&type=script&lang=js"
export * from "./TagFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports